import React, { useState, useLayoutEffect, useEffect } from 'react';

import { BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_LG } from 'constants/breakpoints';
import useDeviceOrientation from 'hooks/use-device-orientation';
import useWindowWidth from 'hooks/use-window-width';

export const DEVICE_TYPE = {
  desktop: 'desktop',
  tablet: {
    portrait: 'tablet-portrait',
    landscape: 'tablet-landscape',
  },
  mobile: {
    portrait: 'mobile-portrait',
    landscape: 'mobile-landscape',
  },
};

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState(DEVICE_TYPE.desktop);

  const [isTouchDevice, setIsTouchDevice] = React.useState(false);
  const windowWidth = useWindowWidth();
  const orientation = useDeviceOrientation();

  useLayoutEffect(() => {
    try {
      document.createEvent('TouchEvent');
      setIsTouchDevice(true);
    } catch (e) {}
  }, [windowWidth]);

  useEffect(() => {
    if (
      windowWidth <= BREAKPOINT_LG &&
      orientation === 'portrait' &&
      windowWidth > BREAKPOINT_SM &&
      isTouchDevice
    ) {
      setDeviceType(DEVICE_TYPE.tablet.portrait);
    } else if (windowWidth > BREAKPOINT_MD && orientation === 'landscape' && isTouchDevice) {
      setDeviceType(DEVICE_TYPE.tablet.landscape);
    } else if (windowWidth <= BREAKPOINT_SM && orientation === 'portrait' && isTouchDevice) {
      setDeviceType(DEVICE_TYPE.mobile.portrait);
    } else if (windowWidth <= BREAKPOINT_MD && isTouchDevice && orientation === 'landscape') {
      setDeviceType(DEVICE_TYPE.mobile.landscape);
    } else {
      setDeviceType(DEVICE_TYPE.desktop);
    }
  }, [isTouchDevice, windowWidth, orientation]);

  return deviceType;
};

export default useDeviceType;
